<div class="form-group">
    <label>{{label}}<em *ngIf="errorMessage">*</em></label>
    <ng-content></ng-content>
    <small *ngIf="hasError()" class="error">{{errorMessage}}</small>
  </div>